import React, { useState } from 'react';
import { Badge, ListGroup, Button, Tabs, Tab } from 'react-bootstrap';
import { FaClock, FaCheck, FaTimes, FaArrowRight, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const LeaveWidget = ({ stats, userRole }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('leave');

  const types = {
    leave: {
      label: 'Leave',
      submitPath: '/wrms/leave-request',
      adminPath: '/wrms/admin',
      approverPath: '/wrms/approvals'
    },
    early_leave: {
      label: 'Early Leave',
      submitPath: '/wrms/early-leave',
      adminPath: '/wrms/admin',
      approverPath: '/wrms/approvals'
    },
    gate_pass: {
      label: 'Gate Pass',
      submitPath: '/wrms/gate-pass',
      adminPath: '/wrms/admin',
      approverPath: '/wrms/approvals'
    },
    extra_work: {
      label: 'Extra Work',
      submitPath: '/wrms/extra-work',
      adminPath: '/wrms/admin',
      approverPath: '/wrms/approvals'
    }
  };

  const currentStats = stats?.[activeTab] || { pending: 0, approved: 0, rejected: 0, recent: [] };

  const handleManageClick = () => {
    let targetPath = '/wrms/approvals';
    if (userRole === 'admin') {
      targetPath = '/leaves';
    } else if (userRole === 'hr') {
      targetPath = '/wrms/admin';
    }
    navigate(targetPath, { state: { typeFilter: activeTab } });
  };

  const getStatusBadgeBg = (status) => {
    const statusLower = status?.toLowerCase();
    if (statusLower === 'approved') return 'success';
    if (statusLower === 'rejected') return 'danger';
    return 'warning';
  };

  return (
    <div className="leave-widget-content">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        variant="pills"
        className="mb-3 nav-fill flex-nowrap gap-1 leave-widget-pills"
        style={{ fontSize: '0.7rem' }}
      >
        {Object.entries(types).map(([key, t]) => (
          <Tab 
            eventKey={key} 
            title={<span className="fw-bold">{t.label}</span>} 
            key={key} 
          />
        ))}
      </Tabs>

      <div className="d-flex justify-content-around mb-3 bg-light p-3 rounded-3 shadow-sm border border-white">
        <div className="text-center">
          <h4 className="mb-0 text-warning fw-bold">{currentStats.pending}</h4>
          <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.62rem' }}>
            <FaClock className="me-1" /> Pending
          </small>
        </div>
        <div className="text-center">
          <h4 className="mb-0 text-success fw-bold">{currentStats.approved}</h4>
          <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.62rem' }}>
            <FaCheck className="me-1" /> Approved
          </small>
        </div>
        <div className="text-center">
          <h4 className="mb-0 text-danger fw-bold">{currentStats.rejected}</h4>
          <small className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.62rem' }}>
            <FaTimes className="me-1" /> Rejected
          </small>
        </div>
      </div>

      <h6 className="fw-bold mb-2 text-dark small text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
        Recent Activity
      </h6>
      <ListGroup variant="flush" className="mb-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {currentStats.recent && currentStats.recent.length > 0 ? (
          currentStats.recent.map((req, idx) => (
            <ListGroup.Item key={idx} className="px-0 py-2 border-0 bg-transparent" style={{ fontSize: '0.85rem' }}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong className="text-dark d-block" style={{ fontSize: '0.85rem' }}>{req.employeeName}</strong>
                  <small className="text-muted" style={{ fontSize: '0.72rem' }}>
                    {req.requestId} · {req.dateString}
                  </small>
                </div>
                <Badge 
                  bg={getStatusBadgeBg(req.status)} 
                  className="text-capitalize px-2 py-1"
                  style={{ fontSize: '0.7rem' }}
                >
                  {req.status}
                </Badge>
              </div>
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item className="px-0 py-3 text-muted text-center italic bg-transparent border-0 opacity-75" style={{ fontSize: '0.85rem' }}>
            No recent requests to display
          </ListGroup.Item>
        )}
      </ListGroup>

      <div className="d-flex gap-2 mt-auto">
        <Button 
          variant="primary" 
          size="sm" 
          className="flex-grow-1 fw-bold text-nowrap"
          style={{ fontSize: '0.8rem' }}
          onClick={() => navigate(types[activeTab].submitPath)}
        >
          <FaPlus className="me-1" /> Create
        </Button>
        <Button 
          variant="outline-secondary" 
          size="sm" 
          className="flex-grow-1 fw-bold text-nowrap"
          style={{ fontSize: '0.8rem' }}
          onClick={handleManageClick}
        >
          Manage <FaArrowRight className="ms-1" />
        </Button>
      </div>
    </div>
  );
};

export default LeaveWidget;
